import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseCommonTitleLayout.module.scss'

const cx = className.bind(style)

type Props = {
  title: string
  description?: string
  children?: React.ReactNode
  count?: number
  lineheight?: number
}

const MyhouseCommonTitleLayout: React.FC<Props> = ({ title, description, children, count, lineheight = 24 }: Props) => {
  return (
    <div className={cx('article')}>
      <h2 className={cx('title')} style={{ lineHeight: `${lineheight}px` }}>
        {title}
      </h2>
      {/* 실제 적용 방식에 따라 0을 노출해야 하는 경우 조건문 제거 */}
      {!!count && count > 1 && <em className={cx('count')}>{count}</em>}
      {/* 오른쪽 추가 정보 */}
      {description && <span className={cx('description')}>{description}</span>}

      {children && children}
    </div>
  )
}

export default MyhouseCommonTitleLayout
